module.exports = __webpack_public_path__ + "static/media/terras-logo-light.04fa7d97.png";